import React from 'react'
import PropTypes from 'prop-types'
import { find } from 'lodash'

import { ProfileField } from '../../../../../../components/generic'
import ResidentProfileSectionWrapper from './ResidentProfileSectionWrapper'
import ResidentImportantContact from './ResidentImportantContact'
import { colors } from '@lmc/common/constants'
import { formatAddress } from '../../../../../../common/utils'

const ResidentProfileImportantPeople = (props) => {
  const {
    family,
    familySetupComplete,
    profile,
    marginTop = 60,
    openFamilyInviteModal,
    resendInvite,
    carers,
    showGP = true,
    residentname,
  } = props

  return (
    <ResidentProfileSectionWrapper
      color={colors.orange}
      icon="social"
      style={{ marginTop }}
      title={residentname || 'Important people'}
      residentImage={residentname ? profile.picture : null}
    >
      {showGP && (
        <div>
          <div className="lmc-card">
            <div style={styles.title}>GP</div>
            {GP_FIELDS.map((field, i) => (
              <ProfileField
                key={i}
                label={field.label}
                style={styles.field}
                value={getValue(field.key, profile)}
              />
            ))}
          </div>
        </div>
      )}
      {profile.importantContacts &&
        profile.importantContacts.length > 0 &&
        profile.importantContacts.map((contact, i) => {
          const carer =
            contact.familyUpdatedBy &&
            find(carers, { id: contact.familyUpdatedBy })

          return (
            <div
              key={`${contact.name?.first}${contact.name?.last}-${contact.telephone}-${contact.email}`}
              style={styles.importantContact}
            >
              <ResidentImportantContact
                carer={carer}
                contact={contact}
                contactNumber={i + 1}
                index={i}
                residentName={profile.name.first}
                resendInvite={resendInvite}
                familySetupComplete={familySetupComplete}
                family={family}
                openModal={() => openFamilyInviteModal(contact, i, profile)}
              />
            </div>
          )
        })}
    </ResidentProfileSectionWrapper>
  )
}

const getValue = (key, profile) => {
  const value = profile[key]
  if (!value) return <span style={styles.noInfo}>No information entered</span>

  if (key === 'gpAddress') {
    return formatAddress(value)
  }
  return value
}

const GP_FIELDS = [
  {
    key: 'gpName',
    label: 'Doctor name',
  },
  {
    key: 'gpSurgeryName',
    label: 'Surgery / Practice name',
  },
  {
    key: 'gpEmail',
    label: 'Email',
  },
  {
    key: 'gpAddress',
    label: 'Address',
  },
  {
    key: 'gpTelephone',
    label: 'Telephone',
  },
]
const styles = {
  field: {
    textAlign: 'left',
  },
  importantContact: {
    marginTop: 30,
  },
  noInfo: {
    color: colors.black,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
  },
}

ResidentProfileImportantPeople.propTypes = {
  profile: PropTypes.object.isRequired,
  family: PropTypes.bool,
  familySetupComplete: PropTypes.bool,
  marginTop: PropTypes.number,
  carers: PropTypes.array,
  resendInvite: PropTypes.func,
  openFamilyInviteModal: PropTypes.func,
}

export default ResidentProfileImportantPeople
